const initialState = {
  isLoggedIn: false,
  showAnnouncement: true
}

const staticUsers = [
  {
    id: 'user-1',
    firstName: 'Michael',
    deepTargetId: '751'
  },
  {
    id: 'user-2',
    firstName: 'KayCee',
    deepTargetId: '2490'
  }
]

const user = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGIN_SUCCESS': {
      let lastUserId = state.lastUserId
      let user
      if (!lastUserId || lastUserId === 'user-2') {
        user = staticUsers[0]
      } else {
        user = staticUsers[1]
      }

      return { ...state, isLoggedIn: true, ...user }
    }
    case 'HIDE_ANNOUNCEMENT': {
      return { ...state, showAnnouncement: false }
    }
    case 'USER_LOGOUT': {
      return { ...initialState, lastUserId: state.id }
    }
    default: {
      return state
    }
  }
}

export default user
